import * as React from 'react'

const SvgDashBoardCourseIcon = (props) => (
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.666748"
      width="48"
      height="48"
      rx="10"
      fill="url(#paint0_linear_3997_87432)"
    />
    <path
      d="M29.7821 27.3582C29.5114 27.6642 29.2273 27.9665 28.9303 28.2635C24.6345 32.5593 19.2526 34.1422 16.9095 31.7991C15.303 30.1926 15.5419 27.158 17.2352 24.0242M19.5564 20.7253C19.8381 20.4049 20.1345 20.0888 20.445 19.7782C24.7408 15.4825 30.1227 13.8996 32.4658 16.2427C34.0733 17.8502 33.833 20.8879 32.1365 24.024M28.9303 19.7782C33.226 24.074 34.8089 29.4559 32.4658 31.7991C30.1227 34.1422 24.7408 32.5593 20.445 28.2635C16.1492 23.9678 14.5663 18.5858 16.9095 16.2427C19.2526 13.8996 24.6345 15.4825 28.9303 19.7782ZM25.6668 24C25.6668 24.5523 25.2191 25 24.6668 25C24.1145 25 23.6668 24.5523 23.6668 24C23.6668 23.4477 24.1145 23 24.6668 23C25.2191 23 25.6668 23.4477 25.6668 24Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3997_87432"
        x1="26.6977"
        y1="1.2889e-06"
        x2="36.6674"
        y2="45.8313"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3F76FF" />
        <stop offset="1" stopColor="#444CE7" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgDashBoardCourseIcon
